import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-radio',
  imports: [],
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.scss',
})
export class RadioComponent {
  /** Identificador único do input; usado para associar o <label> (acessibilidade). */
  @Input() id = '';
  /** Nome do grupo: rádios com o mesmo `name` são mutuamente exclusivos. */
  @Input() name = '';
  /** Valor associado a esta opção. */
  @Input() value: string | number | null = null;
  /** Texto exibido ao lado do rádio. */
  @Input() label = '';
  /** Indica se a opção está selecionada. */
  @Input() checked = false;
  /** Desabilita a opção. */
  @Input() disabled = false;

  /** Emite o evento nativo de seleção quando a opção é marcada. */
  @Output() change = new EventEmitter<Event>();

  onChange(event: Event): void {
    this.checked = (event.target as HTMLInputElement).checked;
    this.change.emit(event);
  }
}
